function loadHighResImage(el) {

    if(el.getAttribute('data-src')) {
        el.onload = () => {
            el.removeAttribute('data-src')
        }
        el.src = el.dataset.src
    }

    if(el.getAttribute('data-lazy-background')) {
        el.style.backgroundImage = `url(${el.dataset.lazyBackground})`
    }
}

function observerCallback(entries) {
    entries.forEach(entry => {
        if(entry.isIntersecting) {
            loadHighResImage(entry.target)
        }
    })
}

export function lazyImages() {

    const images = document.querySelectorAll('img[data-src], [data-lazy-background]')
    const observer = new IntersectionObserver(observerCallback)

    images.forEach(image => observer.observe(image))
}
